<template lang="pug">
  p(:class="{ 'tracking-matrix': shouldDisplayTrackingMatrix }")
    strong(v-if="!shouldDisplayTrackingMatrix" :class="getAuditMemoryCookieStatusLabel(audit.memoryCookieStatus)") {{ audit.memoryCookieStatusReadable }}
    strong(v-else) Tracking Matrix:
      MTrackingAppraisalMatrix(:audit="audit")
</template>

<script>
import Vue from 'vue'
export default Vue.extend({
  props: ['audit'],
  data() {
    return {
      shouldDisplayTrackingMatrix: false
    };
  },
  created() {
    this.shouldDisplayTrackingMatrix = this.checkShouldDisplayTrackingMatrix(this.audit);
  },
  methods: {
    isAuditOlderThanThreeMonths(auditDate) {
      const today = new Date();
      const dateOfAudit = new Date(auditDate);
      const threeMonthsAgo = new Date(today.getFullYear(), today.getMonth() - 3, today.getDate());
      return dateOfAudit < threeMonthsAgo;
    },
    checkShouldDisplayTrackingMatrix(audit) {
      return this.isAuditOlderThanThreeMonths(audit.auditedAt);
    },
    getAuditMemoryCookieStatusLabel(status) {
      if (status === 'IMMEDIATE') return 'badge badge-primary';
      else if (status === 'CONDITIONAL_ON_CMP') return 'badge badge-warning';
      else if (status === 'CONDITIONAL_ON_CMP_AND_REFRESH') return 'badge badge-warning';
      else if (status === 'NO_MEMORY_COOKIE') return 'badge badge-danger';
      else if (status === 'CLOSED_ADVERTISER') return 'badge badge-secondary';
      else if (status === 'NOT_AUDITED') return 'badge badge-secondary';
      else if (status === 'MANUAL_REVIEW') return 'badge badge-secondary';
      else if (status === 'OTHER') return 'badge badge-secondary';
      
      return 'badge badge-secondary';
    }
  }
});
</script>
